import React, { useMemo } from 'react';
import { CustomSelect } from 'web-library';
import { MenuItems } from './model';
import { KeyValueResponse } from '../../api';
import { useGetResitExamLevels } from '../../api-refactored/resit-registration/useGetResitExamLevels';
import { useResitNavigation } from '../../routes/ResitRoute';

export interface ExamLevelOptionProps {
  /** to handle select on change event
   * */
  onChange: (event: KeyValueResponse) => void;

  /** to define select control selected value
   * */
  value: any;
}

/** reusable select component for coordinator resit register option
 * */
const ExamLevelOption: React.FC<ExamLevelOptionProps> = ({
  onChange,
  value,
}: ExamLevelOptionProps) => {
  const { accessToken } = useResitNavigation();
  const { data } = useGetResitExamLevels({ token: accessToken });

  /** reform data into CustomSelect MenuItems
   * */
  const dropDownData = useMemo<MenuItems[]>(() => {
    if (!data) {
      return [];
    }
    return data.map((option) => ({
      children: option.description,
      value: option.code,
      key: `k-${option.code}`,
    }));
  }, [data]);

  const onSelectOptionChange = (selectedValue: any) => {
    if (data && data.length > 0) {
      const selectedOption = data.find((level) => level.code === selectedValue);
      if (selectedOption) {
        onChange(selectedOption);
      }
    }
  };

  return (
    <CustomSelect
      // label={label}
      placeholder="Select Exam Level"
      displayEmpty
      labelId="inputSelectLabel-examLevel"
      id="inputSelect-examLevel"
      onChange={(e) => onSelectOptionChange(e.target.value)}
      menuItems={dropDownData}
      value={value}
      variant="filled"
    />
  );
};
export default ExamLevelOption;
